(function () {
  "use strict";

  /* ==========================================
     NAGAIA Collection v3.9 (2026-08-21) -- THE REDUCTION PASS, PART 1
     - 2026-08-21 #nv2-float EXCISED. assets/nagaia-05oz.js has hidden
       #nv2-float and #nv2-toast with display:none!important on every page
       this file runs on since the 0.5oz overlay went live. This file kept
       rendering both anyway: hundreds of lines painting an interface no
       visitor could see, and inside that dead layer lived two live
       hazards -- a QUANTITY unlock rule (n >= 5) contradicting the $69.50
       PRICE rule used everywhere else, and a guest hook pointing at
       /account/login in violation of the never-point-join-at-account
       rule. All of it is gone. The visible drawer (#nv5-float) is fed by
       the 05oz fetch tee watching /cart.js, so this file's remaining
       duty is to KEEP MAKING those /cart.js requests at the right
       moments (fetchAndRender / reconcileSoon), not to paint anything.
       Success toasts died with the hidden layer; the only surviving
       message is the FAILURE alert (#nv2-alert), which escapes the 05oz
       hide rule by using its own id and inline styles. The instant tick
       on the button itself is untouched.
     - 2026-08-21 QUICK-ADD BATCHED (v3.8). Taps are collected for
       BATCH_WINDOW ms and sent as ONE /cart/add.js with an items[]
       array. On success nothing is verified (add.js already said so) and
       the drawer catches up on a single DEBOUNCED /cart.js, so five
       shades = 2 requests, not 10. Only a FAILED dispatch pays for
       verification. Never auto-resend: a 429 can land AFTER the items
       were added (assets/nagaia-429-fix.js) and a blind retry duplicates
       lines.
     - 2026-08-20 QUICK-ADD SERIALISED (v3.7). 2026-08-12 HARDENED:
       failsafe timer, r.ok checks, busy taps swallowed after
       preventDefault so they cannot fall through to the legacy inline
       handler (double add).
     - Owned badges match by SKU (V2.ownedSkus from
       customer.metafields.custom.owned_skus -- Flow-synced, complete).
       variant_id matching (V2.ownedProducts) kept as fallback.
     - Cards appended by Load More get badges + New-to-You filter
       re-applied via 'nv2:grid-appended' (main-collection.liquid).
     - Quick-add handled here in CAPTURE phase; the inline handler in
       main-collection.liquid is bypassed -- kept there as a fallback for
       the case where this asset fails to load.
     ========================================== */

  var V2 = window.NAGAIA_V2 || { user: "guest", discount: 15, ownedSkus: [], ownedProducts: [], totalColors: 456 },
    isReturning = V2.user === "returning",
    ownedSet = new Set((V2.ownedProducts || []).map(Number)),
    ownedSkuSet = new Set(
      (V2.ownedSkus || [])
        .map(function (s) { return String(s).trim().toUpperCase(); })
        .filter(Boolean)
    ),
    COLOR_MAP = {
      pink: "#F4A0B5", purple: "#9B6FA0", nude: "#D4B8A0", red: "#C0392B",
      blue: "#5B9BD5", green: "#6DAF7E", brown: "#8B6F4E", orange: "#E8A838",
      gray: "#6B6B6B", grey: "#6B6B6B", black: "#1A1A1A", white: "#E8E4E0",
      gold: "#C9A84C", silver: "#B0B0B0", coral: "#E8756D", burgundy: "#800020",
      navy: "#2C3E6B", teal: "#3B8C8C", mint: "#A8D8B9", lavender: "#B39DDB",
      mauve: "#C89EB8", cream: "#F5F0E1", beige: "#D4C5A9", taupe: "#B8A99A",
      charcoal: "#444444", rose: "#E8A0B0", peach: "#F5C4A1", ivory: "#FFFFF0",
      champagne: "#F7E7CE", bronze: "#A67C52", copper: "#B87333", rust: "#B7410E",
      wine: "#722F37", plum: "#7B4F7B", sage: "#9CAF88", olive: "#808000",
      mustard: "#D4A017", terracotta: "#CC6B49", yellow: "#F0D060",
      clear: "#F0F0F0", neutral: "#D4B8A0", dark: "#333333"
    };

  function nv2OwnedCount() {
    return ownedSkuSet.size || ownedSet.size;
  }

  function cardIsOwned(card) {
    var sku = (card.getAttribute("data-sku") || "").trim().toUpperCase();
    if (sku && ownedSkuSet.has(sku)) return true;
    var addBtn = card.querySelector(".nagaia-quick-add");
    if (addBtn) {
      var vid = addBtn.dataset.variantId || addBtn.dataset.productId;
      if (vid && ownedSet.has(Number(vid))) return true;
    }
    return false;
  }

  function titleCase(s) {
    return s.toLowerCase().replace(/(^|[\s\/&-])(\w)/g, function (m, p, c) {
      return p + c.toUpperCase();
    });
  }

  function getHex(label) {
    if (!label) return "";
    var s = label.toLowerCase().trim();
    if (COLOR_MAP[s]) return COLOR_MAP[s];
    var f = s.split(/[\/&\s]/)[0].trim();
    if (COLOR_MAP[f]) return COLOR_MAP[f];
    for (var k in COLOR_MAP) if (s.indexOf(k) !== -1) return COLOR_MAP[k];
    return "";
  }

  function findInput(lbl) {
    var li = lbl.closest("li") || lbl.parentElement;
    return li ? li.querySelector('input[type="checkbox"]') : null;
  }

  /* Failure alert. #nv2-toast is hidden by nagaia-05oz.js with an ID
     selector, so this element uses a DIFFERENT id and inline styles --
     it depends on neither the stylesheet nor the hidden toast. Failures
     must speak; successes are already told by the button's own tick. */
  var alertTimer = null;
  function nv2Alert(text) {
    var t = document.getElementById("nv2-alert");
    if (!t) {
      t = document.createElement("div");
      t.id = "nv2-alert";
      t.setAttribute("role", "status");
      t.style.cssText =
        "position:fixed;left:50%;bottom:88px;transform:translate(-50%,10px);z-index:96;" +
        "background:#1A1A1A;color:#fff;font-family:'Inter Tight',sans-serif;font-size:12.5px;" +
        "font-weight:700;padding:10px 16px;border-radius:22px;box-shadow:0 6px 22px rgba(0,0,0,.25);" +
        "pointer-events:none;opacity:0;transition:opacity .22s,transform .22s;" +
        "max-width:calc(100vw - 32px);text-align:center";
      document.body.appendChild(t);
    }
    t.textContent = text;
    requestAnimationFrame(function () {
      t.style.opacity = "1";
      t.style.transform = "translate(-50%,0)";
    });
    clearTimeout(alertTimer);
    alertTimer = setTimeout(function () {
      t.style.opacity = "0";
      t.style.transform = "translate(-50%,10px)";
    }, 2600);
  }

  /* ==========================================
     1. SINGLE FILTER ROW (mockup spec)
     ========================================== */
  function closePanels(row) {
    (row || document).querySelectorAll(".nv2-dd-panel").forEach(function (p) { p.classList.remove("open"); });
    document.querySelectorAll(".nv2-dd").forEach(function (c) { c.classList.remove("open"); });
  }

  function buildColorPills() {
    var orig = document.querySelector('[id="filter-filter.p.m.custom.color"]');
    if (!orig) return;

    orig.setAttribute("open", "");

    var row = document.getElementById("nagaia-color-row");
    if (!row) {
      row = document.createElement("div");
      row.id = "nagaia-color-row";
      var searchWrapRef = document.querySelector(".nagaia-search-wrap"),
        form = document.querySelector("form.cc-facet-filters");
      if (searchWrapRef) searchWrapRef.parentNode.insertBefore(row, searchWrapRef.nextSibling);
      else if (form) form.parentNode.insertBefore(row, form);
      else return;
    }

    var sw = document.querySelector(".nagaia-search-wrap");
    if (sw && sw.parentNode === row) row.removeChild(sw);

    row.innerHTML = "";

    var colorOpts = [], total = 0, activeColor = null;
    orig.querySelectorAll("li").forEach(function (origLi) {
      var cb = origLi.querySelector('input[type="checkbox"]'),
        origLabel = origLi.querySelector("label"),
        ns = origLi.querySelector(".cc-filter-label") || (origLabel ? origLabel.querySelector("span:first-child") : null),
        cs = origLabel ? origLabel.querySelector("span:last-child") : null;
      if (!cb || !ns || !origLabel) return;
      var rawName = ns.textContent.trim(),
        opt = {
          name: titleCase(rawName),
          hex: getHex(rawName),
          count: cs && cs !== ns ? cs.textContent.trim() : "",
          checked: cb.checked,
          cb: cb,
          labelEl: origLabel
        };
      total += parseInt(opt.count) || 0;
      if (opt.checked) activeColor = opt;
      colorOpts.push(opt);
    });

    var typeGroup = null;
    document.querySelectorAll("summary, h3, h4, legend").forEach(function (h) {
      h.textContent.trim().indexOf("Powder Type") > -1 &&
        (typeGroup = h.closest("fieldset") || h.parentElement);
    });
    var typeOpts = [], activeType = null;
    if (typeGroup) {
      typeGroup.querySelectorAll("label").forEach(function (lbl) {
        var txt = lbl.textContent.trim().replace(/\s+/g, " "),
          parts = txt.match(/^(.+?)\s+(\d+)$/),
          inp = findInput(lbl),
          opt = {
            name: parts ? parts[1] : txt,
            count: parts ? parts[2] : "",
            checked: inp && inp.checked,
            inp: inp,
            labelEl: lbl
          };
        if (opt.checked) activeType = opt;
        typeOpts.push(opt);
      });
    }

    var ul = document.createElement("ul");
    ul.className = "nv2-pills";

    var vmLi = document.createElement("li");
    vmLi.className = "nv2-vm-li";
    var grid = document.querySelector(".product-grid"),
      powderOn = grid && grid.classList.contains("nagaia-powder-mode");
    vmLi.innerHTML =
      '<div class="nv2-vm-seg">' +
      '<button class="nv2-vm-btn' + (powderOn ? "" : " nv2-vm-btn--active") + '" data-mode="nail" id="nagaia-vm-nail" type="button">On Nail</button>' +
      '<button class="nv2-vm-btn' + (powderOn ? " nv2-vm-btn--active" : "") + '" data-mode="powder" id="nagaia-vm-powder" type="button">Powder</button>' +
      "</div>";
    ul.appendChild(vmLi);

    var sLi = document.createElement("li");
    sLi.className = "nv2-pill nv2-search-li" + (sw && sw.classList.contains("nv2-open") ? " on" : "");
    sLi.innerHTML = '<label aria-label="Search shades"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.3-4.3"></path></svg></label>';
    sLi.addEventListener("click", function (e) {
      e.preventDefault();
      var wrap = document.querySelector(".nagaia-search-wrap");
      if (!wrap) return;
      var open = wrap.classList.toggle("nv2-open");
      sLi.classList.toggle("on", open);
      if (open) {
        var inp = document.getElementById("nagaia-collection-search");
        if (inp) inp.focus();
      }
    });
    ul.appendChild(sLi);

    function makeDropdown(id, chipHtml, isActive, buildItems) {
      var li = document.createElement("li");
      li.className = "nv2-pill nv2-dd" + (isActive ? " on" : "");
      li.setAttribute("data-panel", id);
      var lbl = document.createElement("label");
      lbl.innerHTML = chipHtml + '<span class="nv2-caret">\u25BE</span>';
      li.appendChild(lbl);

      var panel = document.createElement("div");
      panel.className = "nv2-dd-panel";
      panel.id = id;
      buildItems(panel);
      row.appendChild(panel);

      lbl.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var wasOpen = panel.classList.contains("open");
        closePanels(row);
        if (!wasOpen) {
          panel.classList.add("open");
          li.classList.add("open");
        }
      });
      return li;
    }

    function ddItem(html, on, onClick) {
      var it = document.createElement("div");
      it.className = "nv2-dd-item" + (on ? " on" : "");
      it.innerHTML = html;
      it.addEventListener("click", function (e) {
        e.preventDefault();
        closePanels(row);
        onClick();
      });
      return it;
    }

    var shadesChipHtml = activeColor
      ? (activeColor.hex ? '<span class="nv2-dot" style="background:' + activeColor.hex + '"></span>' : "") + '<span class="nv2-name">' + activeColor.name + "</span>"
      : '<span class="nv2-name">Shades</span>' + (total > 0 ? '<span class="nv2-count">' + total + "</span>" : "");

    var shadesLi = makeDropdown("nv2-panel-shades", shadesChipHtml, !!activeColor, function (panel) {
      panel.appendChild(ddItem(
        '<span class="nv2-name">All Shades</span>' + (total > 0 ? '<span class="nv2-dd-count">' + total + "</span>" : ""),
        !activeColor,
        function () {
          if (location.search.indexOf("filter.") > -1 && activeColor && !activeType) {
            window.location.href = location.pathname;
            return;
          }
          if (activeColor) activeColor.labelEl.click();
        }
      ));
      colorOpts.forEach(function (opt) {
        panel.appendChild(ddItem(
          (opt.hex ? '<span class="nv2-dot" style="background:' + opt.hex + '"></span>' : "") +
          '<span class="nv2-name">' + opt.name + "</span>" +
          (opt.count ? '<span class="nv2-dd-count">' + opt.count + "</span>" : ""),
          opt.checked,
          function () {
            if (!opt.cb.checked) {
              colorOpts.forEach(function (other) {
                if (other !== opt && other.cb.checked) other.cb.checked = false;
              });
            }
            opt.labelEl.click();
          }
        ));
      });
    });
    ul.appendChild(shadesLi);

    if (typeOpts.length) {
      var typesChipHtml = activeType
        ? '<span class="nv2-name">' + activeType.name + "</span>"
        : '<span class="nv2-name">Types</span>';
      var typesLi = makeDropdown("nv2-panel-types", typesChipHtml, !!activeType, function (panel) {
        panel.appendChild(ddItem(
          '<span class="nv2-name">All Types</span>',
          !activeType,
          function () {
            if (location.search.indexOf("filter.") > -1 && activeType && !activeColor) {
              window.location.href = location.pathname;
              return;
            }
            if (activeType) activeType.labelEl.click();
          }
        ));
        typeOpts.forEach(function (opt) {
          panel.appendChild(ddItem(
            '<span class="nv2-name">' + opt.name + "</span>" +
            (opt.count ? '<span class="nv2-dd-count">' + opt.count + "</span>" : ""),
            opt.checked,
            function () {
              var curInp = opt.inp;
              typeOpts.forEach(function (other) {
                if (other !== opt && other.inp && other.inp.checked && curInp && !curInp.checked) other.inp.checked = false;
              });
              opt.labelEl.click();
            }
          ));
        });
      });
      ul.appendChild(typesLi);
    }

    if (isReturning) {
      var newLi = document.createElement("li");
      newLi.className = "nv2-pill nv2-pill-new";
      newLi.id = "nv2-new-pill";
      var newLbl = document.createElement("label"),
        newCount = total > 0 ? Math.max(0, total - nv2OwnedCount()) : "";
      newLbl.innerHTML =
        '<span class="nv2-name">New to You</span>' +
        (newCount ? '<span class="nv2-count">' + newCount + "</span>" : "");
      newLi.appendChild(newLbl);
      ul.appendChild(newLi);

      newLbl.addEventListener("click", function (e) {
        e.preventDefault();
        var isActive = newLi.classList.contains("on");
        newLi.classList.toggle("on", !isActive);
        filterOwned(!isActive);
      });
    }

    row.appendChild(ul);

    if (sw) row.appendChild(sw);
  }

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".nv2-dd") && !e.target.closest(".nv2-dd-panel")) closePanels();
  });

  /* ========================================== 2. STATS BADGE ========================================== */
  function buildStatsBadge() {
    if (!isReturning) return;
    if (document.getElementById("nv2-stats")) return;
    var searchRow = document.querySelector(".nagaia-search-wrap");
    if (!searchRow) return;

    var owned = nv2OwnedCount();
    var badge = document.createElement("div");
    badge.id = "nv2-stats";
    badge.className = "nv2-stats";
    badge.innerHTML =
      '<span class="nv2-stats-icon">\u2726</span>' +
      '<span class="nv2-stats-text"><span>' +
      owned +
      "</span> / " +
      V2.totalColors +
      ' explored</span><span class="nv2-stats-bar"><span class="nv2-stats-fill" style="width:' +
      Math.min(100, Math.round((owned / V2.totalColors) * 100)) +
      '%"></span></span>';
    badge.addEventListener("click", function () {
      var newPill = document.getElementById("nv2-new-pill");
      newPill && newPill.querySelector("label").click();
    });
    searchRow.appendChild(badge);
  }

  /* ========================================== 3. OWNED BADGES ========================================== */
  function applyOwnedBadges() {
    if (!isReturning) return;
    var cards = document.querySelectorAll(".product-block");
    cards.forEach(function (card) {
      if (card.querySelector(".nv2-owned-badge")) return;

      if (cardIsOwned(card)) {
        card.classList.add("nv2-owned");
        var imgWrap = card.querySelector(".product-block__image") || card,
          badge = document.createElement("div");
        badge.className = "nv2-owned-badge";
        badge.innerHTML =
          '<svg viewBox="0 0 16 16" fill="none" width="10" height="10"><circle cx="8" cy="8" r="7" fill="#3A8B5C"/><path d="M5 8l2 2 4-4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Owned';
        imgWrap.appendChild(badge);

        var quickAdd = card.querySelector(".nagaia-quick-add");
        if (quickAdd && !quickAdd.classList.contains("nagaia-quick-add--soldout")) {
          quickAdd.classList.add("nv2-qa-owned");
          quickAdd.setAttribute("title", "Buy again");
          quickAdd.setAttribute("aria-label", "Buy " + (quickAdd.dataset.productTitle || "this shade") + " again");
        }
      }
    });
  }

  /* ========================================== 4. FILTER OWNED ========================================== */
  function filterOwned(showNewOnly) {
    var cards = document.querySelectorAll(".product-block");
    cards.forEach(function (card) {
      showNewOnly && card.classList.contains("nv2-owned")
        ? card.style.setProperty("display", "none", "important")
        : card.style.setProperty("display", "block", "important");
    });
  }

  /* ==========================================
     5. CART STATE FEED (the float itself lives in nagaia-05oz.js)
     v3.9: everything that PAINTED a cart here is gone -- #nv2-float was
     display:none'd by the 05oz overlay on every page this file runs on.
     The visible drawer (#nv5-float) re-renders whenever its fetch tee
     sees a /cart.js response, so this file's whole remaining job is to
     REQUEST /cart.js at the right moments and keep cartCache fresh for
     the add queue's pre-dispatch snapshots.
     ========================================== */
  var cartCache = null;

  /* pendingDelta: jars whose add.js succeeded but whose /cart.js
     reconcile has not landed yet. Without it, a second batch would
     snapshot a stale cartCache and could mis-attribute a failure as a
     success. Cleared whenever a fresh cart arrives. */
  var pendingDelta = {};

  function fetchAndRender() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        pendingDelta = {};
        cartCache = cart;
        syncHeaderCount(cart);
        /* No painting here: the 05oz tee saw this same response and has
           already re-rendered #nv5-float from it. */
      })
      .catch(function () { /* Silently fail */ });
  }

  /* One reconcile per burst, not one per jar. */
  var reconcileT = null;
  function reconcileSoon() {
    clearTimeout(reconcileT);
    reconcileT = setTimeout(function () { fetchAndRender(); }, 900);
  }

  function syncHeaderCount(cart) {
    var el = document.getElementById("nag-cart-count");
    if (el && cart) el.textContent = cart.item_count;
  }

  /* Kept for external callers (05oz drawer, legacy surfaces): now simply
     refreshes cart state; the tee repaints the visible drawer. */
  window.nv2RenderFloat = function () { fetchAndRender(); };

  /* -- Batched add queue (v3.8). LEADING window: the first tap opens it,
        later taps do NOT reset it, so the worst delay a customer can feel
        is BATCH_WINDOW no matter how fast they tap. The tick is painted
        instantly on the button, so the wait is invisible.
        ATOMICITY: /cart/add.js with an items[] array is all-or-nothing,
        so a failure cannot be blamed on one jar -- settle() diffs the
        reconciled cart against a pre-dispatch snapshot per variant and
        only the jars that truly did not land get "!". Never auto-resend:
        a 429 can arrive AFTER the items were added (nagaia-429-fix.js)
        and a blind retry duplicates lines. -- */
  var BATCH_WINDOW = 600,
    ADD_GAP = 800,
    addNotBefore = 0,
    pendingJobs = [],
    batchTimer = null,
    inFlight = null;

  function qtyOf(cart, variantId) {
    var q = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (Number(it.variant_id) === Number(variantId)) q += it.quantity;
    });
    return q;
  }

  function mergeItems(jobs) {
    var byId = {}, order = [];
    jobs.forEach(function (j) {
      var id = String(j.variantId);
      if (!byId[id]) { byId[id] = { id: id, qty: 0 }; order.push(byId[id]); }
      byId[id].qty += 1;
    });
    return order;
  }

  function settle(jobs, before, cart) {
    var landed = {};
    mergeItems(jobs).forEach(function (o) {
      landed[o.id] = qtyOf(cart, o.id) - (before[o.id] || 0);
    });
    jobs.forEach(function (j) {
      var id = String(j.variantId);
      if (landed[id] > 0) { landed[id] -= 1; j.resolve(cart); }
      else j.reject(new Error("not added"));
    });
  }

  function settleBlind(jobs, posted) {
    jobs.forEach(function (j) {
      if (posted) j.resolve(null); else j.reject(new Error("not added"));
    });
  }

  function dispatchBatch(jobs) {
    var items = mergeItems(jobs), before = {};
    var wait = Math.max(0, addNotBefore - Date.now());
    return (wait ? new Promise(function (r) { setTimeout(r, wait); }) : Promise.resolve())
      .then(function () {
        if (cartCache) return cartCache;
        return fetch("/cart.js").then(function (r) { return r.json(); })
          .then(function (c) { pendingDelta = {}; cartCache = c; return c; });
      })
      .then(function (pre) {
        items.forEach(function (o) {
          before[o.id] = qtyOf(pre, o.id) + (pendingDelta[o.id] || 0);
        });
        addNotBefore = Date.now() + ADD_GAP;
        var ctrl = window.AbortController ? new AbortController() : null;
        var killT = ctrl ? setTimeout(function () { ctrl.abort(); }, 12000) : null;
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: items.map(function (o) {
              return { id: parseInt(o.id, 10), quantity: o.qty };
            })
          }),
          signal: ctrl ? ctrl.signal : undefined
        }).then(function (r) {
          if (killT) clearTimeout(killT);
          if (r.ok) return true;
          if (r.status === 429) {
            var ra = parseFloat(r.headers.get("Retry-After")) || 0;
            addNotBefore = Date.now() + Math.max(ra * 1000, 1500);
          }
          return false;
        }, function () { if (killT) clearTimeout(killT); return false; });
      })
      .then(function (posted) {
        if (posted) {
          /* HAPPY PATH -- 1 request for the whole batch. add.js already
             confirmed it, so there is nothing to verify; the drawer
             catches up on ONE debounced /cart.js instead of one per jar. */
          items.forEach(function (o) {
            pendingDelta[o.id] = (pendingDelta[o.id] || 0) + o.qty;
          });
          jobs.forEach(function (j) { j.resolve(null); });
          reconcileSoon();
          return null;
        }
        /* Only a FAILED dispatch pays for verification -- look before blaming. */
        return fetch("/cart.js").then(function (r) { return r.json(); })
          .then(function (cart) {
            pendingDelta = {};
            cartCache = cart;
            settle(jobs, before, cart);
            syncHeaderCount(cart);
            return cart;
          }, function () { settleBlind(jobs, false); return null; });
      })
      .catch(function () { settleBlind(jobs, false); return null; });
  }

  function flushBatch() {
    if (batchTimer) { clearTimeout(batchTimer); batchTimer = null; }
    if (!pendingJobs.length) return inFlight || Promise.resolve();
    var jobs = pendingJobs.splice(0, pendingJobs.length);
    inFlight = (inFlight || Promise.resolve()).then(
      function () { return dispatchBatch(jobs); },
      function () { return dispatchBatch(jobs); }
    );
    return inFlight;
  }

  function queuedAdd(variantId) {
    return new Promise(function (resolve, reject) {
      pendingJobs.push({ variantId: variantId, resolve: resolve, reject: reject });
      if (!batchTimer) {
        batchTimer = setTimeout(function () { batchTimer = null; flushBatch(); }, BATCH_WINDOW);
      }
    });
  }

  /* Shared with the search dropdown in sections/main-collection.liquid so
     dropdown adds ride the same paced, verified queue as the cards instead
     of firing their own parallel, unchecked request. */
  window.nv2QueuedAdd = queuedAdd;

  function hasPendingAdds() { return pendingJobs.length > 0 || !!batchTimer; }

  /* A batch still inside its window would be lost if the customer heads to
     the cart within BATCH_WINDOW. Intercept ONLY while something is pending:
     flush, await, then navigate. */
  document.addEventListener("click", function (e) {
    if (!hasPendingAdds()) return;
    var a = e.target.closest ? e.target.closest("a[href]") : null;
    if (!a) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.host !== location.host) return;
    if (!/\/cart(\/|$)/.test(u.pathname) && !/\/checkout(\/|$)/.test(u.pathname)) return;
    e.preventDefault();
    var dest = a.href;
    function go() { window.location.href = dest; }
    flushBatch().then(go, go);
  }, true);

  /* Last resort for a hard exit (back button, tab close, external link). */
  window.addEventListener("pagehide", function () {
    if (!pendingJobs.length || !navigator.sendBeacon) return;
    try {
      var items = mergeItems(pendingJobs).map(function (o) {
        return { id: parseInt(o.id, 10), quantity: o.qty };
      });
      navigator.sendBeacon("/cart/add.js",
        new Blob([JSON.stringify({ items: items })], { type: "application/json" }));
      pendingJobs.length = 0;
    } catch (err) { /* nothing more we can do here */ }
  });

  /* -- Quick-add: instant tick on the button, network in background.
        Capture phase intercepts before the inline handler in
        main-collection.liquid. v3.9: the toast arithmetic that used to
        run here spoke into a hidden element and is gone; the button tick
        and the failure alert are the entire voice of this handler. -- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest(".nagaia-quick-add") : null;
    if (!btn || btn.classList.contains("nagaia-quick-add--soldout")) return;
    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;
    e.preventDefault();
    e.stopPropagation();
    /* Busy taps are swallowed AFTER preventDefault -- before this fix they
       fell through to the legacy inline handler (double add). */
    if (btn.dataset.nv2Busy) return;

    btn.dataset.nv2Busy = "1";
    /* FAILSAFE: a hung/queued request must never brick the button.
       30s covers the 12s request cap plus realistic queue depth. */
    clearTimeout(btn.__nv2Guard);
    btn.__nv2Guard = setTimeout(function () {
      delete btn.dataset.nv2Busy;
      btn.innerHTML = '<span class="nv2-qa-ic">+</span>';
      btn.classList.remove("nagaia-quick-add--added");
    }, 30000);

    btn.innerHTML = '<span class="nv2-qa-ic">\u2713</span>';
    btn.classList.add("nagaia-quick-add--added");

    function resetBtn(errored) {
      clearTimeout(btn.__nv2Guard);
      btn.innerHTML = '<span class="nv2-qa-ic">' + (errored ? "!" : "+") + "</span>";
      btn.classList.remove("nagaia-quick-add--added");
      if (errored) {
        nv2Alert("Couldn't add \u2014 tap to try again");
        setTimeout(function () {
          btn.innerHTML = '<span class="nv2-qa-ic">+</span>';
          delete btn.dataset.nv2Busy;
        }, 1400);
      } else {
        delete btn.dataset.nv2Busy;
      }
    }

    queuedAdd(variantId)
      .then(function () {
        /* Success: the queue has either repainted from a verification
           cart or scheduled ONE debounced reconcile -- never fetch per
           button. */
        setTimeout(function () { resetBtn(false); }, 700);
      })
      .catch(function () {
        reconcileSoon();
        resetBtn(true);
      });
  }, true);

  /* External adds still announce via cart:updated -- but our own queue must
     never trigger it, or every batch would cost an extra /cart.js. */
  document.addEventListener("cart:updated", function () {
    fetchAndRender();
  });

  /* ========================================== 6. HIDE ORIGINAL SIDEBAR ========================================== */
  function hideOriginal() {
    var selectors = [
      ".cc-facet-filters__filter-wrapper",
      ".cc-sidebar-filter",
      ".cc-facet-filters__mobile-open-btn",
      "button[data-cc-toggle-filters]",
      ".cc-active-filters"
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (e) {
        e.style.cssText = "display:none!important";
      });
    });
    document.querySelectorAll(".cc-filter").forEach(function (d) {
      d.style.cssText = "display:none!important";
    });
    var form = document.querySelector("form.cc-facet-filters");
    if (form) {
      form.style.cssText =
        "position:absolute!important;width:1px!important;height:1px!important;" +
        "overflow:hidden!important;clip:rect(0,0,0,0)!important;clip-path:inset(50%)!important;" +
        "border:0!important;padding:0!important;margin:-1px!important";
    }
  }

  /* ========================================== BOOT + TRIGGERS ========================================== */
  function boot() {
    var old = document.getElementById("nagaia-finish-row");
    if (old) old.remove();
    buildColorPills();
    buildStatsBadge();
    applyOwnedBadges();
    hideOriginal();
    fetchAndRender();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("filters-applied", function () {
    setTimeout(function () {
      buildColorPills();
      applyOwnedBadges();
      hideOriginal();
      /* Cart didn't change on a filter -- nothing to refetch. */
    }, 300);
  });

  /* NAGAIA 2026-07-22: Load More appends cards without firing 'filters-applied' --
     main-collection.liquid dispatches this event so appended cards get
     owned badges and the active New-to-You filter immediately. */
  document.addEventListener("nv2:grid-appended", function () {
    applyOwnedBadges();
    var newPill = document.getElementById("nv2-new-pill");
    if (newPill && newPill.classList.contains("on")) filterOwned(true);
  });

  (function watch() {
    var t = document.querySelector("form.cc-facet-filters");
    if (!t) { setTimeout(watch, 1e3); return; }
    var debounce = null;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        buildColorPills();
        applyOwnedBadges();
        hideOriginal();
      }, 400);
    }).observe(t, { childList: !0, subtree: !0 });
  })();

})();